<template>
  <transition name="fade">
    <div 
      v-show="isVisible" 
      class="back-top"
      @click="scrollToTop"
    >
      <img src="../assets/images/backtop.png" alt="返回顶部" style="height: 24px; width: auto;">
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BackTop',
  data() {
    return {
      isVisible: false,
      scrollTimer: null
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.scrollTimer) {
      clearInterval(this.scrollTimer)
    }
  },
  methods: {
    handleScroll() {
      // 当滚动距离超过500px时显示返回顶部按钮
      this.isVisible = window.pageYOffset > 500
    },
    scrollToTop() {
      const start = window.pageYOffset
      const end = 0
      const duration = 600 // 动画持续时间
      const startTime = performance.now()
      
      const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime
        const progress = Math.min(elapsed / duration, 1)
        // 使用缓动函数使滚动更自然
        const easeInOutQuad = t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
        const scrollY = start + (end - start) * easeInOutQuad(progress)
        
        window.scrollTo(0, scrollY)
        
        if (progress < 1) {
          requestAnimationFrame(animateScroll)
        }
      }
      
      requestAnimationFrame(animateScroll)
    }
  }
}
</script>

<style scoped>
.back-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background-color: #007bff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 999;
}

.back-top:hover {
  background-color: #0056b3;
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.back-top .iconfont {
  font-size: 20px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

@media (max-width: 767px) {
  .back-top {
    width: 40px;
    height: 40px;
    bottom: 20px;
    right: 20px;
  }
  
  .back-top .iconfont {
    font-size: 16px;
  }
}
</style>